class BESSAppAccessibleToCouncil extends BESSAppModal {

    constructor() {
        super('councilAccess');

        this.sidebarTrigger = $('.app-visible-to-council-trigger');
        this.sidebarContainer = this.sidebarTrigger.parent();
        this.isAccessibleToCouncilInput = $('#projectIsAccessibleToCouncil');
        this.isNotAccessibleToCouncilInput = $('#projectIsNotAccessibleToCouncil');

        this.isAccessibleToCouncilInput.change(this.#changed.bind(this));
        this.isNotAccessibleToCouncilInput.change(this.#changed.bind(this));

        this.sidebarTrigger.bindClickEvent(this, function (e) {
            e.preventDefault();
            this.open();
            return -1;
        }.bind(this));
    }

    rebind() {
        this.sidebarTrigger = $('.app-visible-to-council-trigger');
        this.sidebarContainer = this.sidebarTrigger.parent();
        this.sidebarTrigger.bindClickEvent(this, function (e) {
            e.preventDefault();
            this.open();
            return -1;
        }.bind(this));
    }


    open(onShownFn) {
        let council = $('.app-project-council-name').text();
        $('#councilAccess .council').text(council);
        let isAccessibleToCouncil = this.sidebarContainer.hasClass('app-visible-to-council');
        this.isAccessibleToCouncilInput.setCheckedIf(isAccessibleToCouncil);
        this.isNotAccessibleToCouncilInput.setCheckedIf(!isAccessibleToCouncil);

        super.open(onShownFn);
    }

    #changed() {
        let isAccessibleToCouncil = this.isAccessibleToCouncilInput.is(':checked');
        this.sidebarContainer.addClassIf('app-visible-to-council', isAccessibleToCouncil);
        this.sidebarContainer.addClassIf('app-not-visible-to-council', !isAccessibleToCouncil);

        BESSApp.instance.services.api.project.apiUpdateAccessibleToCouncil(isAccessibleToCouncil);
    }

}